import { render, staticRenderFns } from "./LawDamagesClaimTypeForm.vue?vue&type=template&id=144ee88c&"
import script from "./LawDamagesClaimTypeForm.vue?vue&type=script&lang=js&"
export * from "./LawDamagesClaimTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./LawDamagesClaimTypeForm.vue?vue&type=style&index=0&id=144ee88c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports